<template>
  <div>
    <CrudList
        title="Reseñas"
        storeName="Reviews"
        parentStoreName="Providers"
        parentUrlKey="user_id"
        :canAdd="false"
        :canEdit="false"
        :canDelete="true"
        labelAddNew="Crear Nuevo"
        labelEdit="Editar"
        labelDelete="Eliminar"
        labelBack="Atrás"
    >
      <template v-slot:profile_picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.provider_job_id">
              <img :src="item.provider_job_id.user_id.profile_picture" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
      <template v-slot:full_name="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-card-text class="text-center" v-if="item.provider_job_id">
              <p>{{ item.provider_job_id.user_id.full_name }}</p>
            </v-card-text>
          </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: {CrudList},
  data: () => ({
    offsetTop: 0,
  }),
  methods: {
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },

  },
};
</script>
